import { useTranslation } from 'react-i18next';
import { badgeVariants } from '@/Domain/components/Shared/Badge/Badge';
import { cn } from '@/Domain/utils/cn';

export const LastUsedBadge = ({ id }: { id: string }) => {
  const { t } = useTranslation('login');

  return (
    <span
      id={id}
      aria-hidden="true"
      data-testid="login-last-used-badge"
      className={cn(
        badgeVariants({ variant: 'secondary' }),
        'pointer-events-none absolute -end-2 -top-3 whitespace-nowrap bg-card text-muted-foreground shadow-xs',
      )}
    >
      {t('last_used')}
    </span>
  );
};
